import React, { useState, useEffect } from "react";
import LoginComponent from "../gst-verify/components/gstComponent";
import { Footer } from "../gst-verify/components/componentsIndex";
import "../../components/Header.css";
import "../gst-verify/gst_login.css";
import LogoutIcon from "@mui/icons-material/Logout";

import MenuIcon from "@mui/icons-material/Menu";
import HomeIcon from "@mui/icons-material/Home";
import PersonIcon from "@mui/icons-material/Person";

import headerlogo from "../../assets/images/abc-logo.png";
import logo from "../../assets/images/vendor-portal.jpg";
import { AuthAPI } from "../../services/dbApi";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userName, setUserName] = useState("");

  // useEffect(() => {
  //   AuthAPI.sessionStatus()
  //     .then((res) => {
  //       if (res.data.valid) {
  //         setIsLoggedIn(true);
  //       } else {
  //         setIsLoggedIn(false);
  //       }
  //     })
  //     .catch(() => setIsLoggedIn(false));
  // }, []);

  // useEffect(() => {
  //   AuthAPI.sessionStatus()
  //     .then((res) => setIsLoggedIn(res.data.valid))
  //     .catch(() => setIsLoggedIn(false));
  // }, []);

  useEffect(() => {
    AuthAPI.sessionStatus()
      .then((res) => {
        setIsLoggedIn(res.data.valid);

        if (res.data.valid) {
          setUserName(res.data.userName);
        }
      })
      .catch(() => setIsLoggedIn(false));
  }, []);

  const navigate = useNavigate();

  // const handleDelete = () => {
  //   AuthAPI.logout()
  //     .then(() => {
  //       navigate("/gst-verify");
  //       localStorage.removeItem("token");
  //     })
  //     .catch((err) => console.log(err));
  // };

  const handleDelete = async () => {
    try {
      await AuthAPI.logoutgst();

      localStorage.removeItem("token");

      navigate("/Business-GSTIN-Verification", { replace: true });
      setIsLoggedIn(false);

      window.location.reload(); // clears state completely
    } catch (err) {
      console.log(err);
    }
  };
  /* Header Responsive Code */
  const [activeMenu, setActiveMenu] = useState(true);
  const [screenSize, setScreenSize] = useState(null);

  useEffect(() => {
    const handleResize = () => setScreenSize(window.innerWidth);
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (screenSize < 1024) {
      setActiveMenu(false);
    } else {
      setActiveMenu(true);
    }
  }, [screenSize]);

  return (
    <>
      {/* Header */}
      <div className="header-container">
        <div className="header-main">
          <div className="header-logo">
            <img src={headerlogo} alt="Aditya Birla Capital" className="logo" />
          </div>

          <div className="header-right">
            {/* <div className="user-profile">
              <h5>Home</h5>
              <HomeIcon />
            </div> */}

            {/* <div className="user-profile">
              <h5>Login</h5>
              <PersonIcon />
              <h5>{userName}</h5>
            </div> */}
            <div className="user-profile">
              {!userName && <h5>Login</h5>}

              <PersonIcon />

              {userName && <h5>{userName}</h5>}
            </div>
            {/* <div className="btn">
              <LogoutIcon onClick={handleDelete} />
              <h5>Logout</h5>
            </div> */}

            {isLoggedIn && (
              <div className="btn" onClick={handleDelete}>
                <LogoutIcon />
                <h5>Logout</h5>
              </div>
            )}

            <div
              id="btn-toggle-menu"
              onClick={() => setActiveMenu(!activeMenu)}
            >
              <MenuIcon />
            </div>
          </div>
        </div>
      </div>

      {/* Login Section */}
      <div className="gst-page">
        <div className="form-container">
          <div className="form-wrapper">
            <img src={logo} alt="Partner-Portal" className="logo-class" />

            {/* <LoginComponent /> */}
            <LoginComponent
              setIsLoggedIn={setIsLoggedIn}
              setUserName={setUserName}
            />
          </div>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </>
  );
};

export default Login;
